import { render } from "./User.vue?vue&type=template&id=06f0a91c&scoped=true"
import script from "./User.vue?vue&type=script&lang=js"
export * from "./User.vue?vue&type=script&lang=js"

import "./User.vue?vue&type=style&index=0&id=06f0a91c&scoped=true&lang=css"

import exportComponent from "D:\\laragon\\www\\subeasy\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06f0a91c"]])

export default __exports__